module.exports = __webpack_public_path__ + "img/service-icon-1.e8a0fb04.png";